var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',{attrs:{"title":"Editar plantilla"}},[_c('formulario',{attrs:{"plantilla-contenido":_vm.plantillaContenido,"paises-id":_vm.paisesId,"opciones-paises":_vm.opcionesPaises},on:{"submit":_vm.actualizar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }